import { AxiosResponse, isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

export interface ExportFormState {
  cntDiasAntesCierreStacking?: number;
  cntDiasAntesComOP?: number;
  cntDiasEarlyArrival?: number;
  cntDiasFueraVentana?: number;
  cobraEarlyArrival: boolean;
  cobraLateArrival: boolean;
  esIMO: boolean;
  esOOG: boolean;
  esReefer: boolean;
  tamanioContenedor: number;
  esOperado: boolean;
}

export const generateExport = async (
  formData: ExportFormState
): Promise<AxiosResponse> => {
  const ctDiasStacking = (formData?.cntDiasAntesCierreStacking ?? 0) + 1;

  const cntDiasAntesComOP = (formData?.cntDiasAntesComOP ?? 0) + 1;
  try {
    const res = await apiClient.post<AxiosResponse>(Endpoints.SimuladorExport, {
      ...formData,
      cntDiasAntesCierreStacking: ctDiasStacking,
      cntDiasAntesComOP,
      cntDiasEarlyArrival: 0,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error?.response?.data[0].errorMessage);
    }
    throw error;
  }
};
